<template>
  <div class="container-layout">
    <v-row id="layoutRow">
      <v-col sm="4">
        <div id="titleDiv">
          <h1 id="titleH1">Mystic Vessels</h1>
        </div>

        <Containers @click-container="handleClickContainer" />
      </v-col>
      <v-col sm="4">
        <ContainerDetail v-if="containerNFTInfo.image != undefined" :containerNFTInfo="containerNFTInfo" />
        <SeasonOneDetail v-if="seasonOneNFTInfo.image != undefined" :seasonOneNFTInfo="seasonOneNFTInfo" />
      </v-col>
      <v-col sm="4">
        <div id="titleDiv" class="gurucore-title-div" v-if="seasonOneNFTs.length != 0">
          <h1 id="titleH1">Guru Core Set</h1>
        </div>

        <SeasonOneGurus @update-seasononegurus="handleSeasonOneGurusUpdate" @click-seasononegurus="handleClickSeasonOneGurus" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Containers from './Containers';
  import ContainerDetail from './ContainerDetail';
  import SeasonOneGurus from './SeasonOneGurus';
  import SeasonOneDetail from './SeasonOneDetail';

  export default {
    name: 'Container',
    components: {
      Containers,
      ContainerDetail,
      SeasonOneGurus,
      SeasonOneDetail
    },
    data: () => ({
      containerNFTInfo: {},

      seasonOneNFTs: [],
      seasonOneNFTInfo: {},
    }),
    mounted() {
    },
    methods: {
      handleClickContainer(pContainerInfo) {
        this.containerNFTInfo = {};
        this.seasonOneNFTInfo = {};
        
        this.containerNFTInfo.tokenId = pContainerInfo.tokenId;
        this.containerNFTInfo.image = pContainerInfo.image;
        this.containerNFTInfo.name = pContainerInfo.name;
        this.containerNFTInfo.desc = pContainerInfo.desc;
      },
      handleSeasonOneGurusUpdate(pSeasonOneGurus) {
        this.seasonOneNFTs = pSeasonOneGurus;
      },
      handleClickSeasonOneGurus(pSeasonOneNFTInfo) {
        this.containerNFTInfo = {};
        this.seasonOneNFTInfo = {};

        this.seasonOneNFTInfo.tokenId = pSeasonOneNFTInfo.tokenId;
        this.seasonOneNFTInfo.image = pSeasonOneNFTInfo.image;
        this.seasonOneNFTInfo.name = pSeasonOneNFTInfo.name;
        this.seasonOneNFTInfo.desc = pSeasonOneNFTInfo.desc;
        this.seasonOneNFTInfo.attrs = pSeasonOneNFTInfo.attrs;
      },
    },
    computed: {
    },
  };
</script>

<style scoped>
  p, h1, h2 {
    margin: 0px;
  }

  #titleDiv {
    background-image: url(https://dev.mysticgurus.club/wp-content/uploads/2022/02/woodsign.svg);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    text-align: center;
  }
  #titleDiv #titleH1 {
    font-weight: 600;
    text-shadow: 2px 2px 3px rgb(255 255 255 / 30%);
    font-family: Architects Daughter;
    color: #333;
    padding: 5px 20px;
  }
  #layoutRow {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Container/index.vue